import React from "react";

const HeroSection = ({ showHero, heroContent }) => {
  return (
    <div
      className="hero-section text-white d-flex"
      style={{
        backgroundImage: `url("${heroContent.backgroundImage}")`,
      }}
    >
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background:
            "linear-gradient(89.77deg, rgba(8,40,8,0.5) 37.58%, rgba(2,72,2,0.5) 71%)",
          zIndex: 1,
        }}
      />
      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row align-items-center">
          <div
            className="col-12 col-md-6 mb-4 mb-md-0"
            style={{
              transform: showHero ? "translateX(0)" : "translateX(-100px)",
              opacity: showHero ? 1 : 0,
              transition: "all 1s ease-out",
            }}
          >
            <div style={{ maxWidth: "636px" }}>
              <h1 className="fw-bold">{heroContent.title}</h1>
              <p className="lead">{heroContent.description}</p>
            </div>
          </div>
          <div
            className="col-12 col-md-6 text-center text-md-end"
            style={{
              transform: showHero ? "translateX(0)" : "translateX(100px)",
              opacity: showHero ? 1 : 0,
              transition: "all 1s ease-out",
            }}
          >
            <img
              src={heroContent.sideImage}
              alt="Illustration"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
